
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexHuOcoXGWZATdpi1A94ipMN8yOGyGjMD50RiwsnpgXy4Meta } from "/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/index.vue?macro=true";
import { default as contactrFbeGIFicKJiJ58U5_45_45kZogM4qifYDq2qac77pagw9QMeta } from "/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/contact.vue?macro=true";
import { default as partnersz16JJucBsl_45z5FiSWoe55oX44gMc0oGM9W6l0hMzEjMMeta } from "/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/partners.vue?macro=true";
import { default as indext0Pa_ycz3ssBzsnAGMLBEKYTy8_45vBJ1Zc7SRDGpA_45n8Meta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/index.vue?macro=true";
import { default as profileunvoe1VmmZSjA4NXZneMLZpKNRoUYttuY2L4WKB6A3MMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/profile.vue?macro=true";
import { default as indexLCzfLY_jSh70r2Mr2JMH7KylkGL7xBOgTvIfAsVu2EkMeta } from "/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/login/index.vue?macro=true";
import { default as tournamentstVaBAQ9n3wohS6Xxj384LTzOsXdmmbeNRoQ_45wj6py4wMeta } from "/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/tournaments.vue?macro=true";
import { default as by_45level5_45g2HS35dvXKV0qU5Zkd8Pk8oeNe6I11on84kgaVzaUMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/by-level.vue?macro=true";
import { default as magazine0CMkO97CWq7KsGb5HlYUGQGV8C4xEykDXjT0apDL5ngMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/magazine.vue?macro=true";
import { default as indexsdA7_zqW21nuQykMbvNrIjytkGlIxAFec_45hp472or_45cMeta } from "/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/gallery/index.vue?macro=true";
import { default as subscribengHEnSdTjRlffV6dVZJ9E2byj3fPHV48hnd4zcOvXRMMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/subscribe.vue?macro=true";
import { default as _91slug_939eDYQH9QoOxibUXGRBHor78xEEzagcwOEG7znrZytrIMeta } from "/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/gallery/[slug].vue?macro=true";
import { default as indexTUaXHJct6b_1MjpQwWhLz5ucPMyaVfkrG_uADoUw5QMMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/blog/index.vue?macro=true";
import { default as play_45learnkoZAH_4593yUwZ5wE8kMiqOL4sqqSzss5rAmros1xY2yYMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/play-learn.vue?macro=true";
import { default as _91portal_931Y49WWcG7SGTT7h7TV2XzMeZXACnkJj3wcW3spjgjnoMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/login/[portal].vue?macro=true";
import { default as all_45content0diVwVfTXMbbF0EZXmirSbgBGVVoFyFSlCMmSRPGk68Meta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/all-content.vue?macro=true";
import { default as leaderboardkfSqfjwhhv2_45TCu1hKrKqEz7x93r7_45sRFxcpfJUJhnEMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/leaderboard.vue?macro=true";
import { default as membershipswaF0gtLY5QuD1Sh3SR9i4PbZaAjSpNYz2YYNsEUKJ3QMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/memberships.vue?macro=true";
import { default as indexKMVtV8xpsWLYLXK0lCz79ThThUwKTqeGa8JqC_45LmzuMMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/video/index.vue?macro=true";
import { default as successjMj0tMWM7RuWxfg6Y8A93lXSKd5tyMi_wGqgcbsZmsIMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/payment/success.vue?macro=true";
import { default as _91slug_93zc0oR2SNNXvut7YmKu9Jzq3MahP8fiZ2KSAL0k1eULEMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/level/[slug].vue?macro=true";
import { default as tournament_45entryGk_45iYIPkEf_45JkNAO5UnA8RBidNX9mOiuyNs8SzMz5P4Meta } from "/Users/mauriciomateus/sites/ipa-lms/pages/tournament-entry.vue?macro=true";
import { default as tournamentsDkx9bCBfLucuxf7bIBS__45ZIIN_kZ0v3QFoAYFDfi4esMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/embed/tournaments.vue?macro=true";
import { default as club_45listingsQRYS6v3Am5PBacEnZ6v58E3VYeAmIjGz_45VAZ7E5Hlx8Meta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/club-listings.vue?macro=true";
import { default as indexPPr7ML6OmVQud_ijoeYy_45PG1XGdaCx7SSfbNTfEfoAAMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/gallery/index.vue?macro=true";
import { default as indexXFAL52R6LZalgbYXPXgWAtyWlkUWIYL5_45VZcZA0uA2EMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium/index.vue?macro=true";
import { default as subscriptionsPSsBPz18mFBrw35i_JDKFiNVzANhGnI3WS413kTdINoMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/subscriptions.vue?macro=true";
import { default as indexcg6_c3QV3VdUiX3Emy_NveDg7WF8QUouqjju2qSPjXoMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/chukkers/index.vue?macro=true";
import { default as _91slug_93ciRMQC9E_45TqZrqfP_450jfoIVT_8AAPNbeaaQxoMUgUr0Meta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/gallery/[slug].vue?macro=true";
import { default as nuxt_45error_45examplesTV6OhX8x9tXZWYSFlqbIgkNfekVLyySjTaMT227AsEMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/nuxt-error-example.vue?macro=true";
import { default as _91postSlug_93AZLZT_45cPCXviWSVvoZoOZyQG5M0x_45Yiar5TtNV0_pGQMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/blog/[postSlug].vue?macro=true";
import { default as sentry_45example_45pageoSL4yq0E1zlhO6XqC8VOQ5r6WcpJhVrteatYCSUxsVYMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/sentry-example-page.vue?macro=true";
import { default as wow_45polo_45gives_45back04ULn_45ZH41PVclESqmypUltXqefUnvlLX8McVuHAN4wMeta } from "/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/wow-polo-gives-back.vue?macro=true";
import { default as premium_45packagesd922KraEyf82k8B9BO6PsK_ufihyLBY4JuTMcvo_xkQMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium-packages.vue?macro=true";
import { default as _91slug_93FkZFcRnXfkTDjbJh0zKJxM_8zi1OXL17OgeVFNTLz3YMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/membership/[slug].vue?macro=true";
import { default as indexpxbTy3nSJ_gbRiLprtY7M_y_fQWXbmll_457xQtgEPcbUMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/tournaments/index.vue?macro=true";
import { default as uspa_45post_45login_45actionEoEvHIrrECKZfHGgMRlTMxVFep9hzKRkCxm0U_45TvInAMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/uspa-post-login-action.js?macro=true";
import { default as indexQgxdkUSnrRG5AbjVft46b9ogObRCa6FKQjBgxMhCW4gMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/contributors/index.vue?macro=true";
import { default as _91slug_938ZuqO_45g_B_459O6eK9AER5qRrcYV_45Idiok3OdmjHMMth0Meta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/contributors/[slug].vue?macro=true";
import { default as _91slug_93vRk9q4fHwi7NKn8jxlPMJnVQSzvYvqBLABmTSRBQ_FkMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/blog/category/[slug].vue?macro=true";
import { default as _91bundleSlug_93peqkQo5rKV_B8xPdVDrhlxoYKkD3fmhf1V7GbUsHl90Meta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium/[bundleSlug].vue?macro=true";
import { default as _91courseSlug_93NXGkF7vE_45llLR_45DMG3UiT9POXXviq5SOhjfXbYtBTbEMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium/[courseSlug].vue?macro=true";
import { default as contributor_45contact_45vyV932lFlkJxMsSjE5tPJTMcHlMGVsg08PVhOX1hp4Meta } from "/Users/mauriciomateus/sites/ipa-lms/pages/forms/contributor-contact.vue?macro=true";
import { default as indexwIboejIOP764mFhy8qWI52O_lyygRXITQDhKnph8TPkMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/course-categories/index.vue?macro=true";
import { default as _91slug_9360e6yB1I_45DAypyLHLf9BcPF_usH0HQtmrkZTDO76eNkMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/course-categories/[slug].vue?macro=true";
import { default as indexjGv_45oH0KFR3gVruKLef34EkDTEt29sTzSbxXyDn7xkoMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/courses/[courseSlug]/index.vue?macro=true";
import { default as _91_91videoSlug_93_93tzg3U_45EuChkBEzGAafHYKA9dY3_45pnNXeJpA3LmnRutsMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/video/[slug]/[[videoSlug]].vue?macro=true";
import { default as indexJWjnKijADdiI3GS_ly1NDI5SmE1XYB8UlKZKuJBWuvsMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium-subscriptions/index.vue?macro=true";
import { default as bundlesP4JMfxEwJ5srAYrWStUHMTxLuBnszRwJHPM5oxrTmYsMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/courses/[courseSlug]/bundles.vue?macro=true";
import { default as _91lessonSlug_93_45HIJi5kEBeOH0vRxEqR3ISLrwXQ3UOHbZPNnolxIkTgMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/courses/[courseSlug]/[lessonSlug].vue?macro=true";
import { default as _91courseSlug_937RT54M7zMsgWVNf9fDeZES6vffGIx1f4rsTHQ1X9BTgMeta } from "/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium-subscriptions/[courseSlug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexHuOcoXGWZATdpi1A94ipMN8yOGyGjMD50RiwsnpgXy4Meta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactrFbeGIFicKJiJ58U5_45_45kZogM4qifYDq2qac77pagw9QMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/contact.vue")
  },
  {
    name: "partners",
    path: "/partners",
    meta: partnersz16JJucBsl_45z5FiSWoe55oX44gMc0oGM9W6l0hMzEjMMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/partners.vue")
  },
  {
    name: indext0Pa_ycz3ssBzsnAGMLBEKYTy8_45vBJ1Zc7SRDGpA_45n8Meta?.name ?? "lms",
    path: "/lms",
    meta: indext0Pa_ycz3ssBzsnAGMLBEKYTy8_45vBJ1Zc7SRDGpA_45n8Meta || {},
    alias: ["/"],
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/index.vue")
  },
  {
    name: profileunvoe1VmmZSjA4NXZneMLZpKNRoUYttuY2L4WKB6A3MMeta?.name ?? "lms-profile",
    path: "/lms/profile",
    meta: profileunvoe1VmmZSjA4NXZneMLZpKNRoUYttuY2L4WKB6A3MMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/profile.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/login/index.vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    meta: tournamentstVaBAQ9n3wohS6Xxj384LTzOsXdmmbeNRoQ_45wj6py4wMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/tournaments.vue")
  },
  {
    name: by_45level5_45g2HS35dvXKV0qU5Zkd8Pk8oeNe6I11on84kgaVzaUMeta?.name ?? "lms-by-level",
    path: "/lms/by-level",
    meta: by_45level5_45g2HS35dvXKV0qU5Zkd8Pk8oeNe6I11on84kgaVzaUMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/by-level.vue")
  },
  {
    name: magazine0CMkO97CWq7KsGb5HlYUGQGV8C4xEykDXjT0apDL5ngMeta?.name ?? "lms-magazine",
    path: "/lms/magazine",
    meta: { ...(magazine0CMkO97CWq7KsGb5HlYUGQGV8C4xEykDXjT0apDL5ngMeta || {}), ...{"middleware":["staging-only"]} },
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/magazine.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    meta: indexsdA7_zqW21nuQykMbvNrIjytkGlIxAFec_45hp472or_45cMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/gallery/index.vue")
  },
  {
    name: subscribengHEnSdTjRlffV6dVZJ9E2byj3fPHV48hnd4zcOvXRMMeta?.name ?? "lms-subscribe",
    path: "/lms/subscribe",
    meta: subscribengHEnSdTjRlffV6dVZJ9E2byj3fPHV48hnd4zcOvXRMMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/subscribe.vue")
  },
  {
    name: "gallery-slug",
    path: "/gallery/:slug()",
    meta: _91slug_939eDYQH9QoOxibUXGRBHor78xEEzagcwOEG7znrZytrIMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/gallery/[slug].vue")
  },
  {
    name: indexTUaXHJct6b_1MjpQwWhLz5ucPMyaVfkrG_uADoUw5QMMeta?.name ?? "lms-blog",
    path: "/lms/blog",
    meta: indexTUaXHJct6b_1MjpQwWhLz5ucPMyaVfkrG_uADoUw5QMMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/blog/index.vue")
  },
  {
    name: play_45learnkoZAH_4593yUwZ5wE8kMiqOL4sqqSzss5rAmros1xY2yYMeta?.name ?? "lms-play-learn",
    path: "/lms/play-learn",
    meta: play_45learnkoZAH_4593yUwZ5wE8kMiqOL4sqqSzss5rAmros1xY2yYMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/play-learn.vue")
  },
  {
    name: _91portal_931Y49WWcG7SGTT7h7TV2XzMeZXACnkJj3wcW3spjgjnoMeta?.name ?? "login-portal",
    path: "/login/:portal()",
    meta: _91portal_931Y49WWcG7SGTT7h7TV2XzMeZXACnkJj3wcW3spjgjnoMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/login/[portal].vue")
  },
  {
    name: all_45content0diVwVfTXMbbF0EZXmirSbgBGVVoFyFSlCMmSRPGk68Meta?.name ?? "lms-all-content",
    path: "/lms/all-content",
    meta: all_45content0diVwVfTXMbbF0EZXmirSbgBGVVoFyFSlCMmSRPGk68Meta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/all-content.vue")
  },
  {
    name: leaderboardkfSqfjwhhv2_45TCu1hKrKqEz7x93r7_45sRFxcpfJUJhnEMeta?.name ?? "lms-leaderboard",
    path: "/lms/leaderboard",
    meta: { ...(leaderboardkfSqfjwhhv2_45TCu1hKrKqEz7x93r7_45sRFxcpfJUJhnEMeta || {}), ...{"middleware":["leaderboard-guard"]} },
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/leaderboard.vue")
  },
  {
    name: membershipswaF0gtLY5QuD1Sh3SR9i4PbZaAjSpNYz2YYNsEUKJ3QMeta?.name ?? "lms-memberships",
    path: "/lms/memberships",
    meta: membershipswaF0gtLY5QuD1Sh3SR9i4PbZaAjSpNYz2YYNsEUKJ3QMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/memberships.vue")
  },
  {
    name: indexKMVtV8xpsWLYLXK0lCz79ThThUwKTqeGa8JqC_45LmzuMMeta?.name ?? "lms-video",
    path: "/lms/video",
    meta: indexKMVtV8xpsWLYLXK0lCz79ThThUwKTqeGa8JqC_45LmzuMMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/video/index.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/payment/success.vue")
  },
  {
    name: _91slug_93zc0oR2SNNXvut7YmKu9Jzq3MahP8fiZ2KSAL0k1eULEMeta?.name ?? "lms-level-slug",
    path: "/lms/level/:slug()",
    meta: _91slug_93zc0oR2SNNXvut7YmKu9Jzq3MahP8fiZ2KSAL0k1eULEMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/level/[slug].vue")
  },
  {
    name: "tournament-entry",
    path: "/tournament-entry",
    meta: tournament_45entryGk_45iYIPkEf_45JkNAO5UnA8RBidNX9mOiuyNs8SzMz5P4Meta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/tournament-entry.vue")
  },
  {
    name: "embed-tournaments",
    path: "/embed/tournaments",
    meta: tournamentsDkx9bCBfLucuxf7bIBS__45ZIIN_kZ0v3QFoAYFDfi4esMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/embed/tournaments.vue")
  },
  {
    name: club_45listingsQRYS6v3Am5PBacEnZ6v58E3VYeAmIjGz_45VAZ7E5Hlx8Meta?.name ?? "lms-club-listings",
    path: "/lms/club-listings",
    meta: club_45listingsQRYS6v3Am5PBacEnZ6v58E3VYeAmIjGz_45VAZ7E5Hlx8Meta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/club-listings.vue")
  },
  {
    name: indexPPr7ML6OmVQud_ijoeYy_45PG1XGdaCx7SSfbNTfEfoAAMeta?.name ?? "lms-gallery",
    path: "/lms/gallery",
    meta: { ...(indexPPr7ML6OmVQud_ijoeYy_45PG1XGdaCx7SSfbNTfEfoAAMeta || {}), ...{"middleware":["gallery-guard"]} },
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/gallery/index.vue")
  },
  {
    name: indexXFAL52R6LZalgbYXPXgWAtyWlkUWIYL5_45VZcZA0uA2EMeta?.name ?? "lms-premium",
    path: "/lms/premium",
    meta: indexXFAL52R6LZalgbYXPXgWAtyWlkUWIYL5_45VZcZA0uA2EMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium/index.vue")
  },
  {
    name: subscriptionsPSsBPz18mFBrw35i_JDKFiNVzANhGnI3WS413kTdINoMeta?.name ?? "lms-subscriptions",
    path: "/lms/subscriptions",
    meta: subscriptionsPSsBPz18mFBrw35i_JDKFiNVzANhGnI3WS413kTdINoMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/subscriptions.vue")
  },
  {
    name: indexcg6_c3QV3VdUiX3Emy_NveDg7WF8QUouqjju2qSPjXoMeta?.name ?? "lms-chukkers",
    path: "/lms/chukkers",
    meta: { ...(indexcg6_c3QV3VdUiX3Emy_NveDg7WF8QUouqjju2qSPjXoMeta || {}), ...{"middleware":["chukkers-guard"]} },
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/chukkers/index.vue")
  },
  {
    name: _91slug_93ciRMQC9E_45TqZrqfP_450jfoIVT_8AAPNbeaaQxoMUgUr0Meta?.name ?? "lms-gallery-slug",
    path: "/lms/gallery/:slug()",
    meta: { ...(_91slug_93ciRMQC9E_45TqZrqfP_450jfoIVT_8AAPNbeaaQxoMUgUr0Meta || {}), ...{"middleware":["gallery-guard"]} },
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/gallery/[slug].vue")
  },
  {
    name: "nuxt-error-example",
    path: "/nuxt-error-example",
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/nuxt-error-example.vue")
  },
  {
    name: _91postSlug_93AZLZT_45cPCXviWSVvoZoOZyQG5M0x_45Yiar5TtNV0_pGQMeta?.name ?? "lms-blog-postSlug",
    path: "/lms/blog/:postSlug()",
    meta: _91postSlug_93AZLZT_45cPCXviWSVvoZoOZyQG5M0x_45Yiar5TtNV0_pGQMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/blog/[postSlug].vue")
  },
  {
    name: "sentry-example-page",
    path: "/sentry-example-page",
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/sentry-example-page.vue")
  },
  {
    name: "wow-polo-gives-back",
    path: "/wow-polo-gives-back",
    meta: wow_45polo_45gives_45back04ULn_45ZH41PVclESqmypUltXqefUnvlLX8McVuHAN4wMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/brands/wowpolo/pages/wow-polo-gives-back.vue")
  },
  {
    name: premium_45packagesd922KraEyf82k8B9BO6PsK_ufihyLBY4JuTMcvo_xkQMeta?.name ?? "lms-premium-packages",
    path: "/lms/premium-packages",
    meta: premium_45packagesd922KraEyf82k8B9BO6PsK_ufihyLBY4JuTMcvo_xkQMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium-packages.vue")
  },
  {
    name: _91slug_93FkZFcRnXfkTDjbJh0zKJxM_8zi1OXL17OgeVFNTLz3YMeta?.name ?? "lms-membership-slug",
    path: "/lms/membership/:slug()",
    meta: _91slug_93FkZFcRnXfkTDjbJh0zKJxM_8zi1OXL17OgeVFNTLz3YMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/membership/[slug].vue")
  },
  {
    name: indexpxbTy3nSJ_gbRiLprtY7M_y_fQWXbmll_457xQtgEPcbUMeta?.name ?? "lms-tournaments",
    path: "/lms/tournaments",
    meta: { ...(indexpxbTy3nSJ_gbRiLprtY7M_y_fQWXbmll_457xQtgEPcbUMeta || {}), ...{"middleware":["tournaments-guard"]} },
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/tournaments/index.vue")
  },
  {
    name: "uspa-post-login-action",
    path: "/uspa-post-login-action",
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/uspa-post-login-action.js")
  },
  {
    name: indexQgxdkUSnrRG5AbjVft46b9ogObRCa6FKQjBgxMhCW4gMeta?.name ?? "lms-contributors",
    path: "/lms/contributors",
    meta: indexQgxdkUSnrRG5AbjVft46b9ogObRCa6FKQjBgxMhCW4gMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/contributors/index.vue")
  },
  {
    name: _91slug_938ZuqO_45g_B_459O6eK9AER5qRrcYV_45Idiok3OdmjHMMth0Meta?.name ?? "lms-contributors-slug",
    path: "/lms/contributors/:slug()",
    meta: _91slug_938ZuqO_45g_B_459O6eK9AER5qRrcYV_45Idiok3OdmjHMMth0Meta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/contributors/[slug].vue")
  },
  {
    name: _91slug_93vRk9q4fHwi7NKn8jxlPMJnVQSzvYvqBLABmTSRBQ_FkMeta?.name ?? "lms-blog-category-slug",
    path: "/lms/blog/category/:slug()",
    meta: _91slug_93vRk9q4fHwi7NKn8jxlPMJnVQSzvYvqBLABmTSRBQ_FkMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/blog/category/[slug].vue")
  },
  {
    name: _91bundleSlug_93peqkQo5rKV_B8xPdVDrhlxoYKkD3fmhf1V7GbUsHl90Meta?.name ?? "lms-premium-bundleSlug",
    path: "/lms/premium/:bundleSlug()",
    meta: _91bundleSlug_93peqkQo5rKV_B8xPdVDrhlxoYKkD3fmhf1V7GbUsHl90Meta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium/[bundleSlug].vue")
  },
  {
    name: "LmsPremiumBundlesForCourse",
    path: "/lms/premium/:courseSlug()",
    meta: _91courseSlug_93NXGkF7vE_45llLR_45DMG3UiT9POXXviq5SOhjfXbYtBTbEMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium/[courseSlug].vue")
  },
  {
    name: "forms-contributor-contact",
    path: "/forms/contributor-contact",
    meta: contributor_45contact_45vyV932lFlkJxMsSjE5tPJTMcHlMGVsg08PVhOX1hp4Meta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/forms/contributor-contact.vue")
  },
  {
    name: indexwIboejIOP764mFhy8qWI52O_lyygRXITQDhKnph8TPkMeta?.name ?? "lms-course-categories",
    path: "/lms/course-categories",
    meta: indexwIboejIOP764mFhy8qWI52O_lyygRXITQDhKnph8TPkMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/course-categories/index.vue")
  },
  {
    name: _91slug_9360e6yB1I_45DAypyLHLf9BcPF_usH0HQtmrkZTDO76eNkMeta?.name ?? "lms-course-categories-slug",
    path: "/lms/course-categories/:slug()",
    meta: _91slug_9360e6yB1I_45DAypyLHLf9BcPF_usH0HQtmrkZTDO76eNkMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/course-categories/[slug].vue")
  },
  {
    name: indexjGv_45oH0KFR3gVruKLef34EkDTEt29sTzSbxXyDn7xkoMeta?.name ?? "lms-courses-courseSlug",
    path: "/lms/courses/:courseSlug()",
    meta: indexjGv_45oH0KFR3gVruKLef34EkDTEt29sTzSbxXyDn7xkoMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/courses/[courseSlug]/index.vue")
  },
  {
    name: _91_91videoSlug_93_93tzg3U_45EuChkBEzGAafHYKA9dY3_45pnNXeJpA3LmnRutsMeta?.name ?? "lms-video-slug-videoSlug",
    path: "/lms/video/:slug()/:videoSlug?",
    meta: _91_91videoSlug_93_93tzg3U_45EuChkBEzGAafHYKA9dY3_45pnNXeJpA3LmnRutsMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/video/[slug]/[[videoSlug]].vue")
  },
  {
    name: indexJWjnKijADdiI3GS_ly1NDI5SmE1XYB8UlKZKuJBWuvsMeta?.name ?? "lms-premium-subscriptions",
    path: "/lms/premium-subscriptions",
    meta: indexJWjnKijADdiI3GS_ly1NDI5SmE1XYB8UlKZKuJBWuvsMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium-subscriptions/index.vue")
  },
  {
    name: bundlesP4JMfxEwJ5srAYrWStUHMTxLuBnszRwJHPM5oxrTmYsMeta?.name ?? "lms-courses-courseSlug-bundles",
    path: "/lms/courses/:courseSlug()/bundles",
    meta: bundlesP4JMfxEwJ5srAYrWStUHMTxLuBnszRwJHPM5oxrTmYsMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/courses/[courseSlug]/bundles.vue")
  },
  {
    name: _91lessonSlug_93_45HIJi5kEBeOH0vRxEqR3ISLrwXQ3UOHbZPNnolxIkTgMeta?.name ?? "lms-courses-courseSlug-lessonSlug",
    path: "/lms/courses/:courseSlug()/:lessonSlug()",
    meta: _91lessonSlug_93_45HIJi5kEBeOH0vRxEqR3ISLrwXQ3UOHbZPNnolxIkTgMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/courses/[courseSlug]/[lessonSlug].vue")
  },
  {
    name: _91courseSlug_937RT54M7zMsgWVNf9fDeZES6vffGIx1f4rsTHQ1X9BTgMeta?.name ?? "lms-premium-subscriptions-courseSlug",
    path: "/lms/premium-subscriptions/:courseSlug()",
    meta: _91courseSlug_937RT54M7zMsgWVNf9fDeZES6vffGIx1f4rsTHQ1X9BTgMeta || {},
    component: () => import("/Users/mauriciomateus/sites/ipa-lms/pages/lms/premium-subscriptions/[courseSlug].vue")
  }
]